<template>
  <vue-easy-lightbox
    :visible="visible"
    :imgs="imageUrl"
    :index="0"
    @hide="handleClose"
    :loop="false"
    :moveDisabled="false"
    :escDisabled="false"
    :rotateDisabled="false"
    :zoomDisabled="false"
  />
</template>

<script setup>
import VueEasyLightbox from 'vue-easy-lightbox';
import 'vue-easy-lightbox/external-css/vue-easy-lightbox.css';

// Props
const props = defineProps({
  visible: {
    type: Boolean,
    default: false
  },
  imageUrl: {
    type: [String, Array],
    default: ''
  }
});

// Emits
const emit = defineEmits(['close', 'update:visible']);

// 关闭弹窗
const handleClose = () => {
  emit('close');
  emit('update:visible', false);
};
</script>

<style scoped>
/* vue-easy-lightbox 样式已内置，无需额外配置 */
</style>

